import React from 'react';
import Button from 'react-bootstrap/Button';
import { useEffect } from 'react';
import { CgCloseR } from "react-icons/cg";
import {
    myData
} from "../dbconnector/connector";

const ActivityreportDetails = ({ rights, t, isDisabled, data, events }) => {

    useEffect(() => {
        //if (data.reportdata !== null)
        //console.log("data", data.reportdata.achternaam)
    }, [data]);



    return (
        <>
            <div id="activityreportdetails" className='assignmentdiv'>
                <div className='formcaptionactivityreport'><div  onMouseDown={(e) => events.startdrag("activityreportdetails", true, e)} onMouseUp={(e) => events.startdrag(null, false, e)} >ActivityReport for {data.reportdata !== null ? data.reportdata.achternaam : ""}, {data.reportdata !== null ? data.reportdata.voornaam : ""}</div><div onClick={events.handleCancel} className='closeknop'><CgCloseR className='closer' /></div></div>
                <div className="ActivityReportform" >
                    <div className="groupbox">

                        <label className='formtitleGroupBox'>Algemeen</label>
                        <div className='formElement reportgroupbox2Col'>
                            <label className='labelhotelnomargin'>
                                {t('FirstName')}
                            </label>
                            <input id="voornaam" name="voornaam" className='reporttextwidth' value={data.reportdata.voornaam} type='text' onChange={events.handleOnchange} disabled>
                            </input>
                            <label className='labelhotelnomargin'>
                                {t('LastName')}
                            </label>
                            <input id="achternaam" name="achternaam" className='reporttextwidth' value={data.reportdata.achternaam} type='text' onChange={events.handleOnchange} disabled>
                            </input>
                        </div>
                        <div className='formElement reportgroupbox'>
                            <label className='labelhotelnomargin'>
                                {t('Year')}
                            </label>
                            <input id="year" name="year" value={data.reportdata.year} className="reporttextwidth" type='text' onChange={events.handleOnchange} disabled>
                            </input>
                            <label className='labelhotelnomargin'>
                                {t('Maand')}
                            </label>
                            <input id="Month" name="Month" value={t(data.reportdata.Month)} className="reporttextwidth" type='text' onChange={events.handleOnchange} disabled>
                            </input>
                            <label className='labelhotelnomargin'>
                                {t('contracturen')}
                            </label>
                            <input id="contracturen" name="contracturen" value={data.reportdata.contracturen_maand} className="reporttextwidth" type='text' onChange={events.handleOnchange} disabled>
                            </input>
                            <label className='labelhotelnomarginleft'>
                                / {t('Monthly')}
                            </label>
                        </div>
                    </div>


                    <div className="groupbox reportgroupbox">
                        <label className='formtitleGroupBox '>Totalen voor maand</label>

                        <label className='labelhotelnomargin'>
                            {t('supervision_uren')}
                        </label>
                        <input id="supervision_uren" name="supervision_uren" value={data.reportdata.supervision_uren} className="reporttextwidth" type='text' onChange={events.handleOnchange} disabled>
                        </input>
                        <label className='labelhotelnomargin'>
                            {t('gewerkte_cleaning_uren')}
                        </label>
                        <input id="gewerkte_cleaning_uren" name="gewerkte_cleaning_uren" value={data.reportdata.gewerkte_cleaning_uren} className="reporttextwidth" type='text' onChange={events.handleOnchange} disabled>
                        </input>
                        <label className='labelhotelnomargin'>
                            {t('totaal-gewerkte-uren')}
                        </label>
                        <input id="supervision_uren" name="supervision_uren" value={Number(data.reportdata.supervision_uren) + Number(data.reportdata.gewerkte_cleaning_uren)} className="reporttextwidth" type='text' onChange={events.handleOnchange} disabled>
                        </input>
                        <label className='labelhotelnomargin'>
                            {t('totaal_gewerkte_dagen')}
                        </label>
                        <input id="gewerkte_cleaning_uren" name="gewerkte_cleaning_uren" value={((Number(data.reportdata.supervision_uren) + Number(data.reportdata.gewerkte_cleaning_uren))/Number(data.reportdata.werkuren_dag)).toFixed(2)} className="reporttextwidth" type='text' onChange={events.handleOnchange} disabled>
                        </input>
                        {/* <label className='labelhotelnomargin'>
                            {t('geregistreerde_cleaning_norm_uren')}
                        </label>
                        <input id="geregistreerde_cleaning_norm" name="geregistreerde_cleaning_norm" value={data.reportdata.geregistreerde_cleaning_norm} className="reporttextwidth" type='text' onChange={events.handleOnchange} disabled>
                        </input>
                        <label className='labelhotelnomargin'>
                            {t('performance_cleaning_rate')}
                        </label>
                        <input id="performance_cleaning_rate" name="performance_cleaning_rate" value={data.reportdata.performance_cleaning_rate} className="reporttextwidth" type='text' onChange={events.handleOnchange} disabled>
                        </input> */}
                        <label className='labelhotelnomargin'>
                            {t('holidays')}
                        </label>
                        <input id="holidays" name="holidays" value={data.reportdata.holidays} className="reporttextwidth" type='text' onChange={events.handleOnchange} disabled>
                        </input>
                        <label className='labelhotelnomargin'>
                            {t('vrijedagen')}
                        </label>
                        <input id="vrijedagen" name="vrijedagen" value={data.reportdata.vrijedagen} className="reporttextwidth" type='text' onChange={events.handleOnchange} disabled>
                        </input>
                        <label className='labelhotelnomargin'>
                            {t('ziektedagen')}
                        </label>
                        <input id="ziektedagen" name="ziektedagen" value={data.reportdata.ziektedagen} className="reporttextwidth" type='text' onChange={events.handleOnchange} disabled>
                        </input>
                        <label className='labelhotelnomargin'>
                            {t('EW')}
                        </label>
                        <input id="EW" name="EW" value={data.reportdata.EW} className="reporttextwidth" type='text' onChange={events.handleOnchange} disabled>
                        </input>
                    </div>
                      <div className="groupbox reportgroupbox">
                        <label className='formtitleGroupBox '>Resultaten</label>
                        <label className='labelhotelnomargin'>
                            {t('daysleft')}
                        </label>
                        <input id="daysleft" name="daysleft" value={data.reportdata.daysleft} className="reporttextwidth" type='text' onChange={events.handleOnchange} disabled>
                        </input>
                        <label className='labelhotelnomargin'>
                            {t('hours_not_yet_accounted')}
                        </label>
                        <input id="hours_not_yet_accounted" name="hours_not_yet_accounted" value={data.reportdata.hours_not_yet_accounted} className="reporttextwidth" type='text' onChange={events.handleOnchange} disabled>
                        </input>
                        <label className='labelhotelnomargin'>
                            {t('estimation_EW')}
                        </label>
                        <input id="hours_not_yet_accounted" name="hours_not_yet_accounted" value={(Number(data.reportdata.hours_not_yet_accounted)/Number(data.reportdata.werkuren_dag)).toFixed(2)} className="reporttextwidth" type='text' onChange={events.handleOnchange} disabled>
                        </input>
                      
        
                    </div>
                    {/* <div id="saveDiv" className="two_Buttons doublegrid">
                        <Button type="button" id="cancelButton" className="Savebutton" onClick={events.handleCancel} >{t('Cancel')}</Button>
                    </div> */}
                </div>
            </div >
        </>
    );
}


export default ActivityreportDetails;
